/**
 * FW-142 — sessiz `'/'` varsayilani KALDIRILDI (olculdu: SPA hep kendi
 * originine istek atiyordu, gercek backend'e hicbir zaman ulasmiyordu —
 * bkz. FW-135 raporu, packages/shell/src/env.ts basligi). Adres artik
 * VITE_WEB_API_BASE_URL derleme-zamani ortam degiskeninden gelir ve
 * eksikse `requireBaseUrl` acilista YUKSEK SESLE durur.
 */
import '@fusapp-work/tokens/tokens.css'
import '@fusapp-work/tokens/cosmos.css'
import '@fusapp-work/ui-kit/cosmos.css'
// Feature utilities are namespaced to .org-feature and must reach composed child views.
import './features/organization/shared/feature.css'
import { createSurfaceApp, requireBaseUrl } from '@fusapp-work/shell'
import App from './App.vue'
import { routes } from './router/routes'
import { createSessionGuard } from './router/sessionGuard'
import { consoleLoginLocation } from './router/consoleReturn'
import { messages } from './locales/messages'
import { installSessionCacheLifecycle } from './composables/sessionCacheLifecycle'

document.documentElement.setAttribute('data-fw-cosmos', 'console')

const surfaceApp = createSurfaceApp({
  locale: { mode: 'resolved' },
  surface: 'console',
  rootComponent: App,
  routes,
  messages,
  apiClientOptions: {
    baseUrl: requireBaseUrl(import.meta.env.VITE_WEB_API_BASE_URL, 'VITE_WEB_API_BASE_URL'),
  },
})

// FW-console-entra-giris — korumali rotalarin session guard'i mount'tan ONCE
// baglanir. `apiClient` `useApiClient()` injection'i DEGIL, createSurfaceApp()'in
// dondurdugu GERCEK istemcidir: bir router guard bilesen setup()'i disinda
// calisir, bkz. router/sessionGuard.ts + composables/useCurrentSession.ts
// basliklari (ayni gerekce, sessionOutcome.ts'te de tekrarlanir).
// The first protected query may fail before Vue Router commits its initial route.
// The browser URL already contains the requested deep link at that point.
const disposeSessionCache = installSessionCacheLifecycle(surfaceApp.queryClient, () => {
  const current = surfaceApp.router.currentRoute.value
  const path = current.name ? current.fullPath : window.location.pathname + window.location.search + window.location.hash
  return surfaceApp.router.replace(consoleLoginLocation(path))
})
surfaceApp.app.onUnmount(disposeSessionCache)
import.meta.hot?.dispose(disposeSessionCache)
surfaceApp.router.beforeEach(createSessionGuard(surfaceApp.apiClient))

surfaceApp.mount('#app')
